import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import ResponsiveMobileStepper from "./ResponsiveMobileStepper";
import NextBackButtons from "./NextBackButtons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { PopupButton } from "react-calendly";

import Smile from "../icons/smile.png";
import Clock from "../icons/clock.png";
import Truck from "../icons/truck.png";
import accounting from "accounting";
import Link from "@material-ui/core/Link";

import { maybePluralize } from "../helpers";

const styles = (theme) => ({
  root: {
    textAlign: "center",
  },
  introText: {
    fontSize: 32,
  },
  card: {
    textAlign: "left",
  },
  content: {
    fontSize: "1.2rem !important", //breaks if not important
    fontWeight: "500 !important", //breaks if not important
    alignItems: "center",
  },
  contentQuoteNote: {
    fontSize: "1.2rem !important", //breaks if not important
    fontWeight: "500 !important", //breaks if not important
    alignItems: "center",
    padding: "16px",
  },
  action: {
    marginTop: "0px",
    marginRight: theme.spacing(-1),
    marginLeft: theme.spacing(4),
  },
  hourlyRateLeftWrapper: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  hourlyRateLeftText: {
    fontSize: "1.2rem",
    fontWeight: "500",
  },
  hourlyRateRightWrapper: {
    textAlign: "right",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
  hourlyRate: {
    fontSize: "2rem",
    fontWeight: "500",
    color: theme.palette.secondary.main,
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: "1rem",
  },
  avatar: {
    width: "50px",
  },
  popupContainer: {
    padding: "0 !important",
    marginBottom: "-3rem",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "0",
    },
  },
  popupText: {
    display: "block",
    "& a": {
      color: "#ff595a",
      fontFamily: "Roboto,Helvetica,Arial,sans-serif",
      fontSize: "14px",
      fontWeight: "500",
      textDecoration: "none",
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: "3rem",
    },
  },
  helpText: {
    fontSize: "16px",
    fontWeight: "500",
  },
  listStyleLeft: {
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    fontSize: "16px",
    textAlign: "left",
  },
  priceToggle: {
    color: "#000",
    fontFamily: "Roboto,Helvetica,Arial,sans-serif",
    fontSize: "14px",
    padding: "0 10px",
    "&:hover": {
      color: "#ff595a",
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  active: {
    color: "#ff595a",
    fontWeight: "500",
  },
  rateNote: {
    fontSize: "12px",
    paddingBottom: ".5rem",
    lineHeight: "1",
    fontStyle: "italic",
  },
  calendlyButton: {
    paddingTop: ".5rem",
    color: "#ff595a",
    border: 0,
    background: 0,
    fontWeight: "500",
    cursor: "pointer",
  },
});

class Quote extends Component {
  constructor(props) {
    super(props);

    this.state = {
      boxesModalOpen: false,
      pricingModalOpen: false,
      calendlyLoaded: false,
      showHourlyRate: true,
      showTotalCost: false,
    };
  }

  componentDidMount() {
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;

    document.head.appendChild(script);
  }

  handleBoxesModalOpen = () => {
    window.dataLayer.push({
      event: "confirm-reservation",
      eventProps: {
        category: "Ecommerce",
        action: "Click",
        label: "Page 5 - Confirm Reservation",
      },
    });

    this.setState({ boxesModalOpen: true });
  };

  handleBoxesModalClose = () => {
    this.setState({ boxesModalOpen: false });
  };

  handlePricingModalOpen = () => {
    this.setState({ pricingModalOpen: true });
  };

  handlePricingModalClose = () => {
    this.setState({ pricingModalOpen: false });
  };

  handleBoxesModalYes = () => {
    window.dataLayer.push({
      event: "need-boxes-yes",
      eventProps: {
        category: "Ecommerce",
        action: "Click",
        label: "Page 5a Do you need boxes? - Yes",
      },
    });

    this.handleBoxesModalClose();
    this.props.handleNext();
  };

  handleBoxesModalNo = () => {
    window.dataLayer.push({
      event: "need-boxes-no",
      eventProps: {
        category: "Ecommerce",
        action: "Click",
        label: "Page 5a Do you need boxes? - No",
      },
    });

    this.handleBoxesModalClose();
    this.props.handleNext(null, true);
  };

  showHourlyRate = () => {
    this.setState({ showHourlyRate: true, showTotalCost: false });
  };

  showTotalCost = () => {
    this.setState({ showHourlyRate: false, showTotalCost: true });
  };

  render() {
    const { classes } = this.props;

    return (
      <Grid container spacing={4} justify="center" className={classes.root}>
        <Grid container justify="center" item xs={12}>
          <Grid item xs={12} sm={8} md={6}>
            <Typography className={classes.introText}>
              Based on the information provided, we recommend the following
              moving plan.
            </Typography>
          </Grid>
        </Grid>

        <Grid container justify="center" item xs={12}>
          <Grid item container xs={12} sm={8} md={6} lg={4}>
            <Grid item xs={12}>
              {this.state.showHourlyRate && (
                <Typography id="hourlyRate">
                  <span className={classes.hourlyRate}>
                    {accounting.formatMoney(this.props.quote.hourlyRate)}{" "}
                  </span>
                  / hour
                </Typography>
              )}
              {this.state.showTotalCost && (
                <Typography id="totalCost">
                  <span className={classes.hourlyRate}>
                    {accounting.formatMoney(
                      this.props.quote.hourlyRate *
                        this.props.quote.estimatedDuration +
                        99
                    )}{" "}
                  </span>{" "}
                  total<sup>*</sup> <br />
                  <span className={classes.rateNote}>
                    <sup>*</sup>includes $99 flat travel fee
                  </span>
                </Typography>
              )}
            </Grid>
            <Grid item xs={12}>
              <Link
                onClick={this.showHourlyRate}
                className={`${classes.priceToggle}  ${
                  this.state.showHourlyRate && classes.active
                }`}
              >
                Hourly Rate
              </Link>{" "}
              |
              <Link
                onClick={this.showTotalCost}
                className={`${classes.priceToggle}  ${
                  this.state.showTotalCost && classes.active
                }`}
              >
                Total Cost
              </Link>
            </Grid>
          </Grid>
        </Grid>

        <Grid container justify="center" item xs={12}>
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <img alt="smile" className={classes.avatar} src={Smile} />
                }
                title={this.props.quote.movers + " moving buddies"}
                classes={{
                  action: classes.action,
                  title: classes.content,
                }}
              />
            </Card>
          </Grid>
        </Grid>

        <Grid container justify="center" item xs={12}>
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <img alt="clock" className={classes.avatar} src={Clock} />
                }
                title={maybePluralize(
                  this.props.quote.estimatedDuration,
                  "estimated hour"
                )}
                classes={{
                  action: classes.action,
                  title: classes.content,
                }}
              />
            </Card>
          </Grid>
        </Grid>

        <Grid container justify="center" item xs={12}>
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Card className={classes.card}>
              <CardHeader
                avatar={
                  <img alt="truck" className={classes.avatar} src={Truck} />
                }
                title={maybePluralize(this.props.quote.trucks, "truck")}
                classes={{
                  action: classes.action,
                  title: classes.content,
                }}
              />
            </Card>
          </Grid>
        </Grid>

        <Grid container justify="center" item xs={12}>
          <Grid item xs={12} sm={8} md={6} lg={4}>
            <Card className={classes.card}>
              <div className={classes.contentQuoteNote}>
                <Typography className={classes.hourlyRateLeftText}>
                  Your estimate includes a professional driver and moving truck,
                  trained movers, moving equipment, tools, furniture pads, and
                  shrink wrap.
                </Typography>
                <ul className={classes.listStyleLeft}>
                  <li>
                    Professional loading, unloading and insured transportation
                  </li>
                  <li>
                    The time starts when our crew arrives – no more paying for
                    travel time
                  </li>
                  <li>Basic furniture disassembly and reassembly</li>
                  <li>
                    <Link
                      onClick={this.handlePricingModalOpen}
                      color="secondary"
                      variant="body1"
                    >
                      Pay-As-You-Go Pricing
                    </Link>{" "}
                    to fit your needs
                  </li>
                  <li>No prepayment or deposit needed </li>
                </ul>
              </div>
            </Card>
          </Grid>
        </Grid>

        <Grid
          container
          justify="center"
          alignItems="center"
          item
          xs={12}
          sm={8}
          md={6}
          lg={6}
          className={classes.popupContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography className={classes.helpText}>
              Want to discuss your estimate?
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            className={classes.popupText}
          >
            <PopupButton
              url="https://calendly.com/moving-buddy"
              text="Schedule time with us"
              className={classes.calendlyButton}
              rootElement={document.getElementById("movingBuddyWidget")}
            />
          </Grid>
        </Grid>

        <Dialog
          open={this.state.boxesModalOpen}
          onClose={this.handleBoxesModalClose}
          aria-labelledby="boxes-dialog-title"
          aria-describedby="boxes-dialog-description"
        >
          <DialogTitle id="boxes-dialog-title">Do you need boxes?</DialogTitle>
          <DialogActions className={classes.dialogActions}>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleBoxesModalYes}
            >
              Yes, I need boxes
            </Button>
          </DialogActions>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this.handleBoxesModalNo}>
              No, I do not need boxes
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.pricingModalOpen}
          onClose={this.handlePricingModalClose}
          aria-labelledby="pricing-dialog-title"
          aria-describedby="pricing-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="pricing-dialog-description">
              Your estimated hours and crew size have been calculated based on
              the information you provided. Your time starts when our crew
              arrives and ends when they depart from your destination. If your
              move is completed before the minimum, then you will pay the 2 hour
              minimum amount. Should your move take longer than 2 hours you will
              be charged in increments of 15 minutes based on your hourly rate.
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={this.handlePricingModalClose}>Close</Button>
          </DialogActions>
        </Dialog>

        <NextBackButtons
          backOnClick={this.props.handleBack}
          nextOnClick={this.handleBoxesModalOpen}
          nextLabel="Confirm Reservation"
        />
        <ResponsiveMobileStepper
          steps={this.props.steps}
          activeStep={this.props.activeStep}
          backOnClick={this.props.handleBack}
          nextOnClick={this.handleBoxesModalOpen}
          nextLabel="Confirm Reservation"
        />
      </Grid>
    );
  }
}

Quote.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.number.isRequired,
  quote: PropTypes.object.isRequired,
  activeStep: PropTypes.number.isRequired,
  handleBack: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
};

export default withStyles(styles)(Quote);
